<div *ngIf='screenWidth > 1230'>
  <!-- <div class="visible-lg"> -->

  <div class="model-padding">
    <div class="bmw-lg-mm-card">
      <div class="bmw-lg-mm-title">
        Model Map
      </div>
      <div *ngIf="display">
        WORKING
      </div>
      <div class="bmw-lg-mm-info">
        Please enter a Model and/or a Series and/or an Engine and/or a Year and a list of
        all applicable BMW or MINI vehicles will dynamically populate that match your entries.
        <br>
        <br> The data available in the dropdowns will be filtered as you make entries to prevent invalid combinations.
        <br>
        <br>Click the Reset button to re-initialize the form if you wish to make new entries.
      </div>
      <div class="bmw-lg-mm-input flex-container">
        <div class="flex-35">
          Model
        </div>
        <div class="flex-2"></div>
        <div class="flex-17">
          Series
        </div>
        <div class="flex-2"></div>
        <div class="flex-25">
          Engine
        </div>
        <div class="flex-2"></div>
        <div class="flex-17">
          Year
        </div>
      </div>
      <div class="bmw-lg-mm-input flex-container">
        <div class="flex-35">
          <input list="model" placeholder="Enter Model" [(ngModel)]='inputModel' id="myBrowser" name="myBrowser" (input)="filterOptions('model')" (change)="onFieldSelected('model')" />
          <datalist id="model">
            <option *ngFor="let model of filteredModelList" [ngValue]="model">{{ model }}</option>
          </datalist>
        </div>
        <div class="flex-2"></div>
        <div class="flex-17">
          <input list="series" placeholder="Enter Series" id="myBrowser" name="myBrowser" [(ngModel)]='inputSeries' (input)="filterOptions('series')" (change)="onFieldSelected('series')" />
          <datalist id="series">
            <option *ngFor="let series of filteredSeriesList" [ngValue]="series">{{ series }}</option>
          </datalist>
        </div>
        <div class="flex-2"></div>
        <div class="flex-25">
          <input list="engine" placeholder="Enter Engine" id="myBrowser" name="myBrowser" [(ngModel)]='inputEngine' (input)="filterOptions('engine')" (change)="onFieldSelected('engine')" />
          <datalist id="engine">
            <option *ngFor="let engine of filteredEngineList" [ngValue]="engine">{{ engine }}</option>
          </datalist>
        </div>
        <div class="flex-2"></div>
        <div class="flex-17">
          <input list="year" placeholder="Enter Year" id="myBrowser" name="myBrowser" [(ngModel)]='inputYear' (input)="filterOptions('year')" (change)="onFieldSelected('year')" />
          <datalist id="year">
            <option *ngFor="let year of filteredYearList" [ngValue]="year">{{ year }}</option>
          </datalist>
        </div>
      </div>
      <div class="bmw-lg-buttons flex-container">
        <div class="bmw-button-secondary pointer flex-20" (click)='resetSearch()'>
          Reset
        </div>
        <div class="flex-4"></div>
        <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary pointer flex-20"
          (click)='viewAllModels()'>
          View All Models
        </div>
      </div>
      <div class="bmw-lg-mm-results-section">
        <div class="bmw-lg-mm-chips flex-container">
          <!-- <div *ngFor='let key of objectKeys'>
            <div *ngIf='searchFilter[key]' class="bmw-lg-mm-chip">
              {{mapFilterKeyToValue[key] + ": " + searchFilter[key]}}
              <i class="material-icons pointer" (click)='removeFromFilter(key)'>close</i>
            </div>
          </div> -->
        </div>
        <div #resultsContent>
          <div class="bmw-lg-mm-results-header flex-container grow" *ngIf='modelMapAll?.length > 0'>
            <div class="bmw-lg-mm-filter-column-title flex-20">Model</div>
            <div class="bmw-lg-mm-filter-column-title flex-15">Series</div>
            <div class="bmw-lg-mm-filter-column-title flex-15">Engine</div>
            <div class="bmw-lg-mm-filter-column-title flex-30">Year</div>
            <div class="bmw-lg-mm-filter-column-title flex">Code</div>
          </div>
          <div class="flex-container flex-container grow" *ngFor='let result of modelMapAll | modalMap: searchFilter'>
            <div class="bmw-lg-mm-results flex-container grow" *ngIf='modelMapAll?.length > 0'>
              <div class="flex-20">{{result?.modelName}}</div>
              <div class="flex-15">{{result?.seriesName}}</div>
              <div class="flex-15">{{result?.engineName}}</div>
              <div class="flex-30">{{result?.year}}</div>
              <div class="flex">{{result?.agCode}}</div>
            </div>
          </div>
        </div>
        <div class="alert alert-warning" role="alert" *ngIf='errorMessage?.length > 0'>{{errorMessage}}</div>
        <div class="bmw-button-secondary bmw-lg-print" (click)="printResults()">
          <i class="material-icons">print</i>
          <div class="bmw-print-label">Print Results</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Ipad Pro HTML -->
<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <!-- <div class="visible-md" (window:orientationchange)="screenRotate($event)"> -->
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-mm-card bmw-md">
      <div class="bmw-lg-mm-title">
        Model Map
      </div>
      <div class="bmw-lg-mm-info">
        Please enter a Model and/or a Series and/or an Engine and/or a Year and a list of
        all applicable BMW or MINI vehicles will dynamically populate that match your entries.
        <br>
        <br> The data available in the dropdowns will be filtered as you make entries to prevent invalid combinations.
        <br>
        <br>Click the Reset button to re-initialize the form if you wish to make new entries.
      </div>
      <div class="bmw-lg-mm-input flex-container">
        <div class="flex-35">
          Model
        </div>
        <div class="flex-2"></div>
        <div class="flex-17">
          Series
        </div>
        <div class="flex-2"></div>
        <div class="flex-25">
          Engine
        </div>
        <div class="flex-2"></div>
        <div class="flex-17">
          Year
        </div>
      </div>
      <div class="bmw-lg-mm-input flex-container">
        <div class="flex-35">
          <input list="model" placeholder="Select or Enter Model" [(ngModel)]='inputModel' id="myBrowser" name="myBrowser" (input)="filterModelMapModel()" />
          <datalist id="model">
            <option *ngFor="let model of modelList" [ngValue]="model">{{ model }}</option>
          </datalist>
        </div>
        <div class="flex-2"></div>
        <div class="flex-17">
          <input list="series" placeholder="Select Series" id="myBrowser" name="myBrowser" [(ngModel)]='inputSeries' (input)="filterModelMapSeries()" />
          <datalist id="series">
            <option *ngFor="let series of seriesList" [ngValue]="series">{{ series }}</option>
            </datalist>
        </div>
        <div class="flex-2"></div>
        <div class="flex-25">
          <input list="engine" placeholder="Select Engine" id="myBrowser" name="myBrowser"
          [(ngModel)]='inputEngine' (input)="filterModelMapEngine()">
            <datalist id="engine">
            <option *ngFor="let engine of engineList" [ngValue]="engine">{{ engine }}</option>
            </datalist>
        </div>
        <div class="flex-2"></div>
        <div class="flex-17">
          <input placeholder="Year" list="year" id="myBrowser" name="myBrowser" [(ngModel)]='inputYear' (input)="filterModelMapYear()">
            <datalist id="year">
            <option *ngFor="let year of yearList" [ngValue]="year">{{ year }}</option>
          </datalist>
        </div>
      </div>
      <div class="bmw-lg-buttons flex-container">
        <div class="bmw-button-secondary pointer flex-20" (click)='resetSearch()'>
          Reset
        </div>
        <div class="flex-4"></div>
      </div>
      <div class="bmw-lg-mm-results-section">
        <div class="bmw-lg-mm-chips flex-container grow">
          <div *ngFor='let key of objectKeys'>
            <div *ngIf='searchFilter[key]' class="bmw-lg-mm-chip">
              {{mapFilterKeyToValue[key] + ": " + searchFilter[key]}}
              <i class="material-icons pointer" (click)='removeFromFilter(key)'>close</i>
            </div>
          </div>
        </div>
        <div #resultsContent>
          <div class="bmw-lg-mm-results-header flex-container" *ngIf='modelMapAll?.length > 0'>
            <div class="bmw-lg-mm-filter-column-title flex-20">Model</div>
            <div class="bmw-lg-mm-filter-column-title flex-15">Series</div>
            <div class="bmw-lg-mm-filter-column-title flex-15">Engine</div>
            <div class="bmw-lg-mm-filter-column-title flex-30">Year</div>
            <div class="bmw-lg-mm-filter-column-title flex">Code</div>
          </div>
          <div class="flex-container flex-container grow" *ngFor='let result of modelMapAll | modalMap: searchFilter'>
            <div class="bmw-lg-mm-results flex-container grow" *ngIf='modelMapAll?.length > 0'>
              <div class="flex-20">{{result?.modelName}}</div>
              <div class="flex-15">{{result?.seriesName}}</div>
              <div class="flex-15">{{result?.engineName}}</div>
              <div class="flex-30">{{result?.year}}</div>
              <div class="flex">{{result?.agCode}}</div>
            </div>
          </div>
        </div>
        <div class="bmw-button-secondary bmw-lg-print" (click)="printResults()">
          <i class="material-icons">print</i>
          <div class="bmw-print-label">Print Results</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Ipad HTML -->
<div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
  <!-- <div class="visible-sm" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-mm-card bmw-sm">
      <div class="bmw-sm-mm-title">
        Model Map
      </div>
      <div class="bmw-sm-mm-info">
        Please enter a Model and/or a Series and/or an Engine and/or a Year and a list of
        all applicable BMW or MINI vehicles will dynamically populate that match your entries.
        <br>
        <br> The data available in the dropdowns will be filtered as you make entries to prevent invalid combinations.
        <br>
        <br>Click the Reset button to re-initialize the form if you wish to make new entries.
      </div>
      <div>
        Model
      </div>
      <div class="flex-55">
        <input list="model" placeholder="Select or Enter Model" [(ngModel)]='inputModel' id="myBrowser" name="myBrowser" (input)="filterModelMapModel()" />
        <datalist id="model">
          <option *ngFor="let model of modelList" [ngValue]="model">{{ model }}</option>
        </datalist>
      </div>
      <div class="bmw-margin-top-10">
        Series
      </div>
      <div class="flex-25">
        <input list="series" placeholder="Select Series" id="myBrowser" name="myBrowser" [(ngModel)]='inputSeries' (input)="filterModelMapSeries()" />
        <datalist id="series">
          <option *ngFor="let series of seriesList" [ngValue]="series">{{ series }}</option>
          </datalist>
      </div>
      <div class="bmw-margin-top-10">
        Engine
      </div>
      <div class="flex-35">
        <input list="engine" placeholder="Select Engine" id="myBrowser" name="myBrowser"
          [(ngModel)]='inputEngine' (input)="filterModelMapEngine()">
            <datalist id="engine">
            <option *ngFor="let engine of engineList" [ngValue]="engine">{{ engine }}</option>
            </datalist>
      </div>
      <div class="bmw-margin-top-10">
        Year
      </div>
      <div class="flex-25">
        <input placeholder="Year" list="year" id="myBrowser" name="myBrowser" [(ngModel)]='inputYear' (input)="filterModelMapYear()">
            <datalist id="year">
            <option *ngFor="let year of yearList" [ngValue]="year">{{ year }}</option>
          </datalist>
      </div>
      <div class="bmw-lg-buttons flex-container">
        <div class="bmw-button-secondary pointer flex-46" (click)='resetSearch()'>
          Reset
        </div>
        <div class="flex-4"></div>
      </div>
      <div class="bmw-lg-mm-results-section">
        <div class="bmw-lg-mm-chips flex-container grow">
          <div *ngFor='let key of objectKeys'>
            <div *ngIf='searchFilter[key]' class="bmw-lg-mm-chip">
              {{mapFilterKeyToValue[key] + ": " + searchFilter[key]}}
              <i class="material-icons pointer" (click)='removeFromFilter(key)'>close</i>
            </div>
          </div>
        </div>
        <div #resultsContent>
          <div class="bmw-lg-mm-results-header flex-container" *ngIf='modelMapAll?.length > 0'>
            <div class="bmw-sm-mm-filter-column-title flex-15">Series</div>
            <div class="bmw-sm-mm-filter-column-title flex-15">Engine</div>
            <div class="bmw-sm-mm-filter-column-title flex-55">Year</div>
            <div class="bmw-sm-mm-filter-column-title flex">Code</div>
          </div>
          <div class="flex-container flex-container grow" *ngFor='let result of modelMapAll | modalMap: searchFilter'>
            <div class="bmw-sm-mm-results flex-container grow" *ngIf='modelMapAll?.length > 0'>
              <div class="flex-15">{{result?.seriesName}}</div>
              <div class="flex-15">{{result?.engineName}}</div>
              <div class="flex-55">{{result?.year}}</div>
              <div class="flex">{{result?.agCode}}</div>
            </div>
          </div>
        </div>
        <div class="bmw-button-secondary bmw-lg-print" (click)="printResults()">
          <i class="material-icons">print</i>
          <div class="bmw-print-label">Print Results</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <!-- <div class="visible-xs" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-xs-mm-card">
      <div class="bmw-sm-mm-title">
        Model Map
      </div>
      <div class="bmw-sm-mm-info">
        Please enter a Model and/or a Series and/or an Engine and/or a Year and a list of
        all applicable BMW or MINI vehicles will dynamically populate that match your entries.
        <br>
        <br> The data available in the dropdowns will be filtered as you make entries to prevent invalid combinations.
        <br>
        <br>Click the Reset button to re-initialize the form if you wish to make new entries.
      </div>
      <div>
        Model
      </div>
      <div class="flex-100">
        <input list="model" placeholder="Select or Enter Model" [(ngModel)]='inputModel' id="myBrowser" name="myBrowser" (input)="filterModelMapModel()" />
          <datalist id="model">
            <option *ngFor="let model of modelList" [ngValue]="model">{{ model }}</option>
          </datalist>
      </div>
      <div class="bmw-margin-top-10">
        Series
      </div>
      <div class="flex-30">
        <input list="series" placeholder="Select Series" id="myBrowser" name="myBrowser" [(ngModel)]='inputSeries' (input)="filterModelMapSeries()" />
        <datalist id="series">
          <option *ngFor="let series of seriesList" [ngValue]="series">{{ series }}</option>
          </datalist>
      </div>
      <div class="bmw-margin-top-10">
        Engine
      </div>
      <div class="flex-50">
        <input list="engine" placeholder="Select Engine" id="myBrowser" name="myBrowser"
          [(ngModel)]='inputEngine' (input)="filterModelMapEngine()">
            <datalist id="engine">
            <option *ngFor="let engine of engineList" [ngValue]="engine">{{ engine }}</option>
            </datalist>
      </div>
      <div class="bmw-margin-top-10">
        Year
      </div>
      <div class="flex-35">
        <input placeholder="Year" list="year" id="myBrowser" name="myBrowser" [(ngModel)]='inputYear' (input)="filterModelMapYear()">
        <datalist id="year">
        <option *ngFor="let year of yearList" [ngValue]="year">{{ year }}</option>
      </datalist>
      </div>
      <div class="bmw-lg-buttons">
        <div class="bmw-button-secondary bmw-xs pointer" (click)='resetSearch()'>
          Reset
        </div>
        <!-- <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-button-primary bmw-xs pointer"
          (click)='searchVehicles()'>
          View Vehicles
        </div> -->
      </div>
      <div class="bmw-lg-mm-results-section">
        <div>
          <div class="bmw-xs-mm-chips">
            <div *ngFor='let key of objectKeys'>
              <div *ngIf='searchFilter[key]' class="bmw-xs-mm-chip">
                {{mapFilterKeyToValue[key] + ": " + searchFilter[key]}}
                <i class="material-icons pointer" (click)='removeFromFilter(key)'>close</i>
              </div>
            </div>
          </div>
        </div>
        <div #resultsContent class="bmw-xs-mm-results-content">
          <div class="bmw-lg-mm-results-header bmw-xs flex-container" *ngIf='modelMapAll?.length > 0'>
            <div class="bmw-sm-mm-filter-column-title flex-95-px">Series</div>
            <div class="bmw-sm-mm-filter-column-title flex-95-px">Engine</div>
            <div class="bmw-sm-mm-filter-column-title flex-275-px">Year</div>
            <div class="bmw-sm-mm-filter-column-title flex-65-px">Code</div>
          </div>
          <div class="flex-container" *ngFor='let result of modelMapAll | modalMap: searchFilter'>
            <div class="bmw-xs-mm-results flex-container grow" *ngIf='modelMapAll?.length > 0'>
              <div class="flex-95-px">{{result?.seriesName}}</div>
              <div class="flex-95-px">{{result?.engineName}}</div>
              <div class="flex-275-px">{{result?.year}}</div>
              <div class="flex-275-px">{{result?.agCode}}</div>
            </div>
          </div>
        </div>
        <div *ngIf='modelMapAll?.length > 0' class="bmw-xs-mm-swipe-label">Swipe left to see more information.</div>
        <div class="bmw-button-secondary bmw-xs-print" (click)="printResults()">
          <i class="material-icons">print</i>
          <div class="bmw-print-label">Print Results</div>
        </div>
      </div>
    </div>
  </div>
</div>